import axios from "axios";
import { EncryptStorage } from "encrypt-storage";
import { startGlobalLoading, stopGlobalLoading } from "./globalLoading";

// import { toast } from "react-toastify";
// toast.configure();

const encryptStorage1 = new EncryptStorage("secret-key", {
  prefix: "@instance1",
});

// axios.interceptors.request.use(
//   (config) => {
//     const data = encryptStorage1.getItem("azalea_user");

//     if (config.headers["reqJWT"] === true) {
//       if (config.headers["jwt"]) {
//         config.headers["Authorization"] = "Bearer " + config.headers["jwt"];
//       } else if (data) {
//         config.headers["Authorization"] = "Bearer " + data.jwt;
//       }
//     }
//     delete config.headers["jwt"];
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

//functions to make api calls
const api = {
  fetchRequest: (
    method,
    headers,
    body,
    finalUrl,
    skipGlobalLoader = false,
    responseType = "",
  ) => {
    if (!skipGlobalLoader) {
      startGlobalLoading();
    }

    return axios({
      method: method,
      headers: headers,
      data: body,
      baseURL: finalUrl,
      ...(responseType ? { responseType } : {}),
    }).finally(() => {
      if (!skipGlobalLoader) {
        stopGlobalLoading();
      }
    });
  },
};
export default api;
